var interfaces_NotificationUpdate = /*#__PURE__*/ function(NotificationUpdate) {
    NotificationUpdate["daily"] = "Daily Updates";
    NotificationUpdate["weekly"] = "Weekly Updates";
    NotificationUpdate["monthly"] = "Monthly Updates";
    NotificationUpdate["quartely"] = "Quarterly Updates";
    NotificationUpdate["annually"] = "Anual Updates";
    return NotificationUpdate;
}({});
const notificationUpdateList = Object.keys(interfaces_NotificationUpdate);
export { interfaces_NotificationUpdate as NotificationUpdate, notificationUpdateList };
